import { createStore } from "vuex";

const date = new Date();
export default createStore({
  state: {
    assnUserToken: "" || localStorage.getItem("assnUserToken"),
    assnUser: "" || localStorage.getItem("assnUser"),
    assnUserMenus: "" || localStorage.getItem("assnUserMenus"),
    assnUserTitles: "" || localStorage.getItem("assnUserTitles"),
    assnUserTabs: "" || localStorage.getItem("assnUserTabs"),
    assnUserPages: "" || localStorage.getItem("assnUserPages"),
  },
  getters: {
    assnUserToken: (state) => state.assnUserToken,
    assnUser: (state) => (!state.assnUser ? [] : JSON.parse(state.assnUser)),
    assnUserMenus: (state) =>
      !state.assnUserMenus ? [] : JSON.parse(state.assnUserMenus),
    assnUserTitles: (state) =>
      !state.assnUserTitles ? [] : JSON.parse(state.assnUserTitles),
    assnUserTabs: (state) =>
      !state.assnUserTabs ? [] : JSON.parse(state.assnUserTabs),
    assnUserPages: (state) =>
      !state.assnUserPages ? [] : JSON.parse(state.assnUserPages),
  },
  mutations: {
    setToken: (state, assnUserToken) => {
      state.assnUserToken = assnUserToken;
      localStorage.setItem("assnUserToken", assnUserToken);
    },
    setUser: (state, assnUser) => {
      state.assnUser = JSON.stringify(assnUser);
      localStorage.setItem("assnUser", JSON.stringify(assnUser));
    },
    logout: (state) => {
      state.assnUserToken = "";
      localStorage.removeItem("assnUserToken");
      state.assnUser = "";
      localStorage.removeItem("assnUser");
      state.assnUserMenus = "";
      localStorage.removeItem("assnUserMenus");
      state.assnUserTitles = "";
      localStorage.removeItem("assnUserTitles");
      state.assnUserTabs = "";
      localStorage.removeItem("assnUserTabs");
      state.assnUserPages = "";
      localStorage.removeItem("assnUserPages");
    },
    // 设置对象数据
    setDatas: (state: any, params) => {
      const datasStr = JSON.stringify(params[1]);
      state[params[0]] = datasStr;
      localStorage.setItem(params[0], datasStr);
    },
  },
  actions: {},
  modules: {},
});
